
<template>
  <div class="loader" :class="{ 'loader--visible': visible }">
    <img src="@/assets/images/loading.gif" />
  </div>
</template>
<script>
export default {
  name: "loader",
  props: ["visible"],
};
</script>
<style lang="scss">
.loader {
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  transition: 0.15s ease-in opacity;
  position: fixed;
  top: 0;
  left: 0;
  pointer-events: none;
  opacity: 0;
  &--visible {
    opacity: 111111;
    pointer-events: all;
  }
  & > img {
    max-width: 120px;
    position: absolute;
    top: 50%;
    margin-top: -60px;
    left: 50%;
    margin-left: -60px;
  }
}
</style>